<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-blue">
                    <div class="card-header">
                        <h4 class="card-title">Delivery Notes</h4>
                        <h5 class="card-subtitle">Available Delivery Notes</h5>
                    </div>

                    <div class="card-body">
                        <div class="table-responsive">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <div class="col-4">
                                        <multiselect
                                                :clear-on-select="false"
                                                :close-on-select="true"
                                                :hide-selected="true"
                                                :internal-search="false"
                                                :options="warehouses"
                                                :searchable="true"
                                                :selectLabel="''"
                                                :show-no-results="false"
                                                @search-change="searchWarehouses"
                                                class="form-control multiselect-sm"
                                                id="from_warehouse"
                                                label="From Warehouse"
                                                name="customer"
                                                open-direction="bottom"
                                                placeholder="From Warehouses"
                                                v-model="from_warehouse">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.name }}</h5>
                                                    <div>{{ props.option.description }}</div>
                                                </div>
                                            </template>
                                            <span slot="noResult">Warehouse not found</span>
                                        </multiselect>
                                    </div>
                                    <div class="col-4">
                                        <multiselect
                                                :clear-on-select="false"
                                                :close-on-select="true"
                                                :hide-selected="true"
                                                :internal-search="false"
                                                :options="warehouses"
                                                :searchable="true"
                                                :selectLabel="''"
                                                :show-no-results="false"
                                                @search-change="searchWarehouses"
                                                class="form-control multiselect-sm"
                                                id="to_warehouse"
                                                label="To Warehouse"
                                                name="customer"
                                                open-direction="bottom"
                                                placeholder="To Warehouses"
                                                v-model="to_warehouse">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.name }}</h5>
                                                    <div>{{ props.option.description }}</div>
                                                </div>
                                            </template>
                                            <span slot="noResult">Purchaser not found</span>
                                        </multiselect>
                                    </div>
                                    <div class="col-2">
                                        <input class="form-control" placeholder="Delivery Note No" type="text" v-model="number">
                                    </div>
                                    <div class="col-2">
                                        <input class="form-control" placeholder="Batch" type="text" v-model="batch">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-4">
                                        <multiselect :clear-on-select="false"
                                                     :close-on-select="true"
                                                     :hide-selected="true"
                                                     :internal-search="false"
                                                     :limit="3"
                                                     :max-height="600"
                                                     :options="goods"
                                                     :options-limit="300"
                                                     :searchable="true"
                                                     :show-no-results="false"
                                                     @search-change="searchGoods"
                                                     class="form-control multiselect-sm"
                                                     data-vv-as="Good"
                                                     id="goodsservice"
                                                     label="goodsservice"
                                                     name="goodsservice"
                                                     open-direction="bottom"
                                                     placeholder="Search Goods/Service"
                                                     selectLabel=""
                                                     track-by="id"
                                                     v-model="good"
                                                     v-validate="'required'">
                                            <template slot="singleLabel" slot-scope="props">
                                                <div class="option__desc">
                                                    <div class="option__desc"
                                                         style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                        {{ props.option.commodity_name }} - {{ props.option.variety }}
                                                    </div>
                                                </div>
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <div class="option__desc" v-if="props.option">
                                                        <h5>{{ props.option.commodity_name }}</h5>
                                                        {{ props.option.variety}}
                                                    </div>
                                                </div>
                                            </template>
                                        </multiselect>
                                    </div>

                                    <div class="col-2">
                                        <input class="form-control" id="startdate" placeholder="Start Date" type="text"/>
                                    </div>

                                    <div class="col-2">
                                        <input class="form-control" id="enddate" placeholder="End Date" type="text"/>
                                    </div>

                                    <div class="col-2">
                                        <div class="btn-group" style="display: flex;">
                                            <button @click="getDeliveryNotes(1)"
                                                    class="btn btn-light btn-outline-success font-weight-bold" style="flex: 1"
                                                    type="button">
                                                <i class="fa fa-search"/> Go!
                                            </button>
                                            <button @click="reset()"
                                                    class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                                    style="flex: 1" type="button">
                                                <i class="fa fa-undo"/> Reset
                                            </button>
                                        </div>
                                    </div>

                                    <div class="col-2 text-right">
                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" title="Exporting, please wait ..."
                                      v-if="exporting">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                        <button aria-expanded="false" aria-haspopup="true"
                                                class="btn waves-effect waves-light btn-outline-info"
                                                data-toggle="dropdown" title="Operations">
                                            <i class="fa fa-grip-vertical"/>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a @click="exportDeliveryNotesAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                                <i class="fa fa-file-excel"/> Export Delivery Notes
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <table class="table no-wrap v-top" v-if="delivery_notes.length >0">
                                <thead>
                                <tr class="border-0 bg-light">
                                    <th class="border-0"><h6>No.</h6></th>
                                    <th class="border-0"><h6>From</h6></th>
                                    <th class="border-0"><h6>To</h6></th>
                                    <th class="border-0"><h6>Commodity</h6></th>
                                    <th class="border-0"><h6>Quantity</h6></th>
                                    <th class="border-0"><h6>Batches</h6></th>
                                    <th class="border-0"><h6>Created At</h6></th>
                                    <th class="border-0 text-center"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(c, index) in delivery_notes">
                                    <td>{{c.number}}</td>
                                    <td>{{c.from_warehouse.name}}</td>
                                    <td>{{c.to_warehouse.name}}</td>
                                    <td>{{c.name}} <span v-if="c.variety">-</span> {{c.variety}}</td>
                                    <td>{{c.quantity | units}}</td>
                                    <td>
                                        <ul>
                                            <li v-for="batch in c.batches">{{batch}}</li>
                                        </ul>
                                    </td>
                                    <td>{{c.created_at | date}}</td>
                                    <td class="text-center">
                                        <h6>
                                            <router-link
                                                    :to="{name: 'viewdeliverynote', params : { deliverynoteid: c.id}}"
                                                    class="ml-3"
                                                    title="Details">
                                                <i class="fa fa-eye"/>
                                            </router-link>
                                            <!--                                    <router-link :to="{name: 'editdeliverynote', params : { deliverynoteid: c.id}}" class="text-info ml-3" title="Edit"-->
                                            <!--                                                 v-if="c.status === 'DRAFT'">-->
                                            <!--                                        <i class="fa fa-edit"/>-->
                                            <!--                                    </router-link>-->
                                            <!--                                    <a @click="delivery_note = c" class="text-danger ml-3" data-target="#deleteModal"-->
                                            <!--                                       data-toggle="modal" href="javascript:void(0)" title="Delete"-->
                                            <!--                                       v-if="c.status === 'DRAFT'">-->
                                            <!--                                        <i class="fa fa-trash-alt"/>-->
                                            <!--                                    </a>-->
                                        </h6>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <template v-else>
                                <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                                <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try
                                    again</h5>
                            </template>
                        </div>
                    </div>
                    <div class="card-footer" v-if="delivery_notes.length>0">
                        <div class="row">
                            <div class="col-6">
                                <div class="row">
                                    <label class="col-form-label p-l-10">Display</label>
                                    <div class="col-auto p-t-5">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                                class="form-control form-control-sm" name="lang_opt_length"
                                                v-model="perPage">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label">Records per page</label>
                                </div>
                            </div>

                            <div class="col-6">
                                <paginate
                                        :click-handler="pageHandler"
                                        :container-class="'pagination float-right mb-0'"
                                        :margin-pages="2"
                                        :next-class="'page-link'"
                                        :next-text="'Next'"
                                        :page-class="'page-link'"
                                        :page-count=pageCount
                                        :page-range="3"
                                        :prev-class="'page-link'"
                                        :prev-text="'Prev'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import Paginate from "vuejs-paginate";
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import XLSX from "xlsx";
    import moment from "moment";

    export default {
        name: "DeliveryNotes",
        components: {Multiselect, Paginate},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                partners: [],
                goods: [],
                delivery_notes: [],
                pageCount: 1,
                total: 0,
                perPage: 10,
                date: null,
                status: null,
                number: null,
                warehouses: [],
                warehouse: null,
                from_warehouse: null,
                to_warehouse: null,
                exporting: false,
                delivery_note: {},
                startdate: null,
                enddate: null,
                partner: null,
                good: null,
                batch: null,
            }
        },
        mounted() {
            let self = this;

            $(function () {
                $('#startdate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.startdate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.startdate = null;
                        }
                    });

                $('#enddate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.enddate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.enddate = null;
                        }
                    });
            });

            this.init();
        },
        methods: {
            async init() {
                await this.getDeliveryNotes(1);
            },
            async getDeliveryNotes(page) {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/deliverynotes`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            batch: this.batch,
                            number: this.number,
                            start: this.startdate,
                            end: this.enddate,
                            from_warehouse: this.from_warehouse ? this.from_warehouse.id : undefined,
                            to_warehouse: this.to_warehouse ? this.to_warehouse.id : undefined,
                            goodid: this.good ? this.good.commodity_id : undefined
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total = data.total;
                    this.delivery_notes = data.delivery_notes;
                    this.setPageCount();
                } catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getDeliveryNotes(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            perPageRecordChange() {
                if (this.isFiltered) {
                    this.getDeliveryNotes(1);
                } else {
                    this.getDeliveryNotes(1);
                }
            },
            async searchWarehouses(search) {
                let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/search`, {
                    params: {
                        search: search
                    }
                });
                this.warehouses = data;
            },
            async reset() {
                $('#startdate, #enddate').datepicker('setDate', null);
                this.number = null;
                this.from_warehouse = null;
                this.to_warehouse = null;
                this.startdate = null;
                this.enddate = null;
                this.good = null;
                this.batch = null;
                await this.getDeliveryNotes(1)
            },
            async deleteDeliveryNote() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/deliverynotes/${this.delivery_note.id}`);
                    this.$toastr('success', 'DeliveryNote deleted', 'Success');
                    await this.init();
                } catch (e) {
                    this.$toastr('error', 'DeliveryNote deletion failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                    $("#deleteModal").modal('hide');
                }
            },
            async searchPartners(searchText) {
                try {
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchGoods(search) {
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/search`, {
                    params: {
                        search,
                        excludeOld: true
                    }
                });
                this.goods = reply.data;
            },
            async exportDeliveryNotesAsExcel(page) {
                try {
                    this.exporting = true;
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/deliverynotes`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            batch: this.batch,
                            number: this.number,
                            start: this.startdate,
                            end: this.enddate,
                            from_warehouse: this.from_warehouse ? this.from_warehouse.id : undefined,
                            to_warehouse: this.to_warehouse ? this.to_warehouse.id : undefined,
                            goodid: this.good ? this.good.commodity_id : undefined
                        }
                    });

                    let delivery_notes = [];
                    let delivery_note_ids = [];
                    let transactions = [];

                    data.delivery_notes.forEach(d => {
                        delivery_notes.push({
                            "Number": d.number,
                            "From Warehouse": d.from_warehouse? d.from_warehouse.name : '',
                            "To Warehouse": d.to_warehouse? d.to_warehouse.name : '',
                            "Commodity": d.name,
                            "Quantity": d.quantity ? d.quantity.amount +d.quantity.unitSymbol : '',
                            "Batches": JSON.stringify(d.batches).replace('[', '').replace(']', '').replace(/"/gi, ''),
                            "Timestamp": moment(d.created_at, "YYYYY-MM-DDTHH:mm:SS").format("DD-MMM-YYYY HH:mm"),
                        });
                        delivery_note_ids.push(d.id);
                    });

                    let workbook = XLSX.utils.book_new();
                    let delivery_note_sheet = XLSX.utils.json_to_sheet(delivery_notes);
                    XLSX.utils.book_append_sheet(workbook, delivery_note_sheet, 'DeliveryNotes');
                    XLSX.writeFile(workbook, 'DeliveryNotes.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
